import { CyclePhases } from "@/female/constants/cycle-based-exp/CyclePhases";

const textByPhase: Record<CyclePhases, string> = {
    [CyclePhases.Menstrual]:
        "Low estrogen levels and reduced energy during the Menstruation phase, which usually lasts from three days to a week, mean it's best to focus on low-intensity exercise.",
    [CyclePhases.Follicular]:
        "In short, higher estrogen levels in the follicular phase can boost your energy and stamina, making it a great time for fitness. Just be sure to listen to your body.",
    [CyclePhases.Ovulation]:
        "The Ovulation phase sees a surge in luteinizing hormone (LH) and peak estrogen, boosting energy and stamina. Great for intense workouts, but listen to your body and adjust your workouts accordingly.",
    [CyclePhases.Luteal]:
        "During your Luteal phase, progesterone levels rise, which can increase fatigue and decrease  performance. Stick to moderate-intensity training and respect your body's changing hormonal levels while still staying active!",
};

export default textByPhase;
